import {ComponentProps} from "react";
import {css} from "@panda/css";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {useLeadFormCloseTracking} from "../../hooks/use_lead_form_close_tracking";
import {LeadFormAskForFullOffer} from "../lead_form/LeadFormAskForFullOffer";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

type IProps = Omit<ComponentProps<typeof LeadFormAskForFullOffer>, "customHeader" | "isTwoColumnGrid" | "showRodoInFooter">;

export const LeadFormModalStandard = (props: IProps) => {
    const {handleModalClose} = props;
    const handleModalCloseWithTracking = useLeadFormCloseTracking(handleModalClose);

    return (
        <LeadFormModalWrapper
            handleModalClose={handleModalCloseWithTracking}
            title="Zapytaj dewelopera o pełną ofertę"
            titleClassName={titleStyle}
            testId={OFFER_TEST_IDS.LEAD_FORM.OFFER_LEAD_FORM}
        >
            <LeadFormAskForFullOffer {...props} handleModalClose={handleModalCloseWithTracking} customHeader={null} isTwoColumnGrid showRodoInFooter={false} />
        </LeadFormModalWrapper>
    );
};

const titleStyle = css({
    textAlign: "left",
    pr: 4,
    md: {
        textAlign: "center"
    }
});
import {ComponentProps} from "react";
import {css} from "@panda/css";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {useLeadFormCloseTracking} from "../../hooks/use_lead_form_close_tracking";
import {LeadFormAskForFullOffer} from "../lead_form/LeadFormAskForFullOffer";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

type IProps = Omit<ComponentProps<typeof LeadFormAskForFullOffer>, "customHeader" | "isTwoColumnGrid" | "showRodoInFooter">;

export const LeadFormModalStandard = (props: IProps) => {
    const {handleModalClose} = props;
    const handleModalCloseWithTracking = useLeadFormCloseTracking(handleModalClose);

    return (
        <LeadFormModalWrapper
            handleModalClose={handleModalCloseWithTracking}
            title="Zapytaj dewelopera o pełną ofertę"
            titleClassName={titleStyle}
            testId={OFFER_TEST_IDS.LEAD_FORM.OFFER_LEAD_FORM}
        >
            <LeadFormAskForFullOffer {...props} handleModalClose={handleModalCloseWithTracking} customHeader={null} isTwoColumnGrid showRodoInFooter={false} />
        </LeadFormModalWrapper>
    );
};

const titleStyle = css({
    textAlign: "left",
    pr: 4,
    md: {
        textAlign: "center"
    }
});
